import { get } from 'lodash';

import Model from 'models';

const Slide = class extends Model {
  get content() {
    return get(this._data, 'content');
  }

  get description() {
    return get(this._data, 'description');
  }

  get heading() {
    return get(this.content, 'heading');
  }

  get subtext() {
    return get(this.content, 'subtext');
  }

  get imageLandscape() {
    return get(this.content, 'desktopImage');
  }

  get imagePortrait() {
    return get(this.content, 'mobileImage');
  }
};

export default Slide;
